import { render, staticRenderFns } from "./BackView.vue?vue&type=template&id=12e64aa4&scoped=true&"
import script from "./BackView.vue?vue&type=script&lang=js&"
export * from "./BackView.vue?vue&type=script&lang=js&"
import style0 from "./BackView.vue?vue&type=style&index=0&id=12e64aa4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e64aa4",
  null
  
)

export default component.exports